<template>
  <v-card class="pa-3">
    <v-row no-gutters>
      <v-col cols="12" class="modal-header py-3 mb-4">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="10">
            <span class="text-center text-lg d-block font-weight-medium w-full"> معاینات </span>
          </v-col>
          <v-col cols="1" class="text-left mt-n2 ml-2">
            <v-icon color="darkColor" @click="closeDialog()">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="stoomakeModal" width="500" persistent>
      <v-card>
        <v-row class="ma-0" no-gutters>
          <v-col cols="12" class="modal-header py-2">
            <v-row class="ma-0" no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-medical-bag</v-icon>
              <span class="modal-title-text mr-2">علائم</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-12">
          <v-row class="ma-0" no-gutters>
            <v-col cols="12">
              <v-autocomplete :items="allStoomakePartNumbers" no-data-text="اطلاعاتی وجود ندارد" tabindex="1" dense
                outlined item-text="title" item-value="id" label="قسمت*" clearable clear-icon="mdi-close-circle-outline"
                :autofocus="true" v-model="selectedPart" autocomplete="off"
                prepend-inner-icon="mdi-human mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="12" v-if="selectedPart">
              <!-- <v-radio-group v-model="selectedStoomakeProblem" row>
                <v-radio v-for="item in allAbdomenExaminationsForOther" :key="item.id" :label="item.title"
                  :value="item"></v-radio>
              </v-radio-group> -->

              <v-checkbox v-for="item in allAbdomenExaminationsForOther" :key="item.id"
                v-model="selectedStoomakeProblems" :label="item.title" :value="item"></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="addStomakeProblem()" dark rounded class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelAddStomakeProblem()"
            class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row class="ma-0 bodyItem" no-gutters>
      <v-col cols="12">
        <v-row class="ma-0">
          <v-col cols="4" v-if="flagShowForm == 3">
            <v-row class="ma-0">
              <span>بررسی قدرت عضلانی عضلات (MT)</span>
              <v-divider class="mt-3 mr-3 ml-3"></v-divider>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="12">
                <v-autocomplete :items="patientBrainStrokeExaminationDetailTypeList" no-data-text="اطلاعاتی وجود ندارد"
                  dense outlined item-text="title" item-value="id" label="دست راست" clearable
                  clear-icon="mdi-close-circle-outline"
                  v-model="patientMediacalExamination.patientBrainStrokeExaminationDetail.rightHand" autocomplete="off"
                  prepend-inner-icon="mdi-hand-back-right mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="12" class="mt-n9">
                <v-autocomplete :items="patientBrainStrokeExaminationDetailTypeList" no-data-text="اطلاعاتی وجود ندارد"
                  dense outlined item-text="title" item-value="id" label="دست چپ" clearable
                  clear-icon="mdi-close-circle-outline"
                  v-model="patientMediacalExamination.patientBrainStrokeExaminationDetail.leftHand" autocomplete="off"
                  prepend-inner-icon="mdi-hand-back-left mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="12" class="mt-n9">
                <v-autocomplete :items="patientBrainStrokeExaminationDetailTypeList" no-data-text="اطلاعاتی وجود ندارد"
                  dense outlined item-text="title" item-value="id" label="پای راست" clearable
                  clear-icon="mdi-close-circle-outline"
                  v-model="patientMediacalExamination.patientBrainStrokeExaminationDetail.rightLeg" autocomplete="off"
                  prepend-inner-icon="mdi-foot-print mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="12" class="mt-n9">
                <v-autocomplete :items="patientBrainStrokeExaminationDetailTypeList" no-data-text="اطلاعاتی وجود ندارد"
                  dense outlined item-text="title" item-value="id" label="پای چپ" clearable
                  clear-icon="mdi-close-circle-outline"
                  v-model="patientMediacalExamination.patientBrainStrokeExaminationDetail.leftLeg" autocomplete="off"
                  prepend-inner-icon="mdi-foot-print mdi-flip-h mdi-18px"></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4">
            <v-row class="ma-0">
              <span>سمع ریه</span>
              <v-divider class="mt-3 mr-3 ml-3"></v-divider>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="12">
                <v-autocomplete :items="allRespiratorySoundsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="id" label="سمع ریه" clearable clear-icon="mdi-close-circle-outline"
                  v-model="patientMediacalExamination.respiratorySoundId" autocomplete="off"
                  prepend-inner-icon="mdi-lungs mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="12" class="mt-n7">
                <v-row class="ma-0">
                  <span class="mr-10">R</span>
                  <v-spacer></v-spacer>
                  <span>صدا</span>
                  <v-spacer></v-spacer>
                  <span class="ml-8">L</span>
                </v-row>
              </v-col>
              <v-col cols="12" class="mt-n6">
                <v-row>
                  <v-switch color="lightColor" flat dense class="mr-6"
                    v-model="patientMediacalExamination.patientRespiratorySoundDetail.rightFineRale" inset></v-switch>
                  <v-spacer></v-spacer>
                  <span class="mt-4">رال فابین</span>
                  <v-spacer></v-spacer>
                  <v-switch flat dense inset color="lightColor"
                    v-model="patientMediacalExamination.patientRespiratorySoundDetail.leftFineRale"></v-switch>
                </v-row>
              </v-col>
              <v-col cols="12" class="mt-n6">
                <v-row>
                  <v-switch color="lightColor" flat dense class="mr-6" v-model="patientMediacalExamination.patientRespiratorySoundDetail.rightCoarseRale
                    " inset></v-switch>
                  <v-spacer></v-spacer>
                  <span class="mt-4">رال کورس</span>
                  <v-spacer></v-spacer>
                  <v-switch flat dense inset color="lightColor" v-model="patientMediacalExamination.patientRespiratorySoundDetail.leftCoarseRale
                    "></v-switch>
                </v-row>
              </v-col>
              <v-col cols="12" class="mt-n6">
                <v-row>
                  <v-switch color="lightColor" flat dense
                    v-model="patientMediacalExamination.patientRespiratorySoundDetail.rightWheeze" class="mr-6"
                    inset></v-switch>
                  <v-spacer></v-spacer>
                  <span class="mt-4">ویز</span>
                  <v-spacer></v-spacer>
                  <v-switch flat dense inset color="lightColor"
                    v-model="patientMediacalExamination.patientRespiratorySoundDetail.leftWheeze"></v-switch>
                </v-row>
              </v-col>
              <v-col cols="12" class="mt-n6">
                <v-row>
                  <v-switch color="lightColor" v-model="patientMediacalExamination.patientRespiratorySoundDetail.rightSoundReduction
                    " flat dense class="mr-6" inset></v-switch>
                  <v-spacer></v-spacer>
                  <span class="mt-4">کاهش صدا</span>
                  <v-spacer></v-spacer>
                  <v-switch flat dense inset color="lightColor" v-model="patientMediacalExamination.patientRespiratorySoundDetail.leftSoundReduction
                    "></v-switch>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4" v-if="flagShowForm != 3">
            <v-row class="ma-0">
              <span>شکم</span>
              <v-divider class="mt-3 mr-3 ml-3"></v-divider>
              <v-btn x-small fab elevation="0" color="darkColor" @click="showStoomakeModal()">
                <v-icon color="white">mdi-plus mdi-18px</v-icon>
              </v-btn>
            </v-row>
            <v-row class="ma-0 customHeight">
              <v-col cols="12" class="mt-n2 h-full">
                <!-- height="28vh" -->
                <v-card elevation="0" class="stomach-card h-full">
                  <v-card-text>
                    <v-row class="ma-0">
                      <v-col cols="6">
                        <v-img :src="stomach" style="cursor: pointer" contain @click="showStoomakeModal()"></v-img>
                      </v-col>
                      <v-col cols="6" class="selected-stomach-probleem-part">
                        <v-row class="ma-0 probleemBox">
                          <v-col class="mt-n4 " cols="12" v-for="(item, index) in allStoomakeProblems" :key="index">
                            <v-card elevation="0">
                              <v-card-text>
                                <v-row class="ma-0">
                                  <v-icon color="darkColor" @click="removeStoomakeProblem(item.id)" class="my-1">
                                    mdi-close-circle
                                  </v-icon>
                                  <span class="mr-3 mt-2">{{ item.part }}</span>
                                  <span class="mr-2 mt-2">{{ item.title }}</span>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4">
            <v-row class="ma-0">
              <span>قلب و عروق</span>
              <v-divider class="mt-3 mr-3 ml-3"></v-divider>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="12" class="mt-n5">
                <v-checkbox v-model="patientMediacalExamination.hadHeartMonitoring" @change="heartMonitoringChange()"
                  label="مانیتورینگ قلبی" hide-details></v-checkbox>
              </v-col>
              <v-col cols="12" class="mt-n1">
                <v-autocomplete :items="allHeartRhythmsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="id" label="ریتم"
                  :disabled="!patientMediacalExamination.hadHeartMonitoring" clearable
                  clear-icon="mdi-close-circle-outline" v-model="patientMediacalExamination.heartRhythmId"
                  autocomplete="off" prepend-inner-icon="mdi-heart-pulse mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="12" class="mt-n9">
                <v-autocomplete :items="allHeartSoundsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="id" label="سمع" clearable
                  :disabled="!patientMediacalExamination.hadHeartMonitoring" clear-icon="mdi-close-circle-outline"
                  v-model="patientMediacalExamination.heartSoundId" autocomplete="off"
                  prepend-inner-icon="mdi-medical-bag mdi-18px"></v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="12" class="mt-n8">
                <v-row class="ma-0">
                  <span>نبض</span>
                  <v-divider class="mt-3 mr-3 ml-3"></v-divider>
                </v-row>
              </v-col>
              <v-col cols="12" class="mt-n4">
                <v-autocomplete :items="allPulseQualitiesForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="id" label="کیفیت نبض" clearable clear-icon="mdi-close-circle-outline"
                  v-model="patientMediacalExamination.pulseQualityId" autocomplete="off"
                  prepend-inner-icon="mdi-clipboard-pulse mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="12" class="mt-n9">
                <v-autocomplete hide-details :items="allPulseRhythmsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                  outlined item-text="title" item-value="id" label="ریتم نبض" clearable
                  clear-icon="mdi-close-circle-outline" v-model="patientMediacalExamination.pulseRhythmId"
                  autocomplete="off" prepend-inner-icon="mdi-pulse mdi-18px"></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4">
            <v-row class="ma-0">
              <span>پوست</span>
              <v-divider class="mt-3 mr-3 ml-3"></v-divider>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="12" class="">
                <v-autocomplete :items="allSkinTurgorsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="id" label="تورگور پوستی" clearable clear-icon="mdi-close-circle-outline"
                  v-model="patientMediacalExamination.skinTurgorId" autocomplete="off"
                  prepend-inner-icon="mdi-human mdi-18px"></v-autocomplete>
              </v-col>
              <!-- <v-col cols="12" class="mt-n9">
                <v-autocomplete :items="allSkinTemperaturesForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="id" label="دمای پوست" clearable clear-icon="mdi-close-circle-outline"
                  v-model="patientMediacalExamination.skinTemperatureId" autocomplete="off"
                  prepend-inner-icon="mdi-thermometer mdi-18px"></v-autocomplete>
              </v-col> -->
              <v-col cols="12" class="mt-n9">
                <v-autocomplete hide-details :items="allSkinExaminationsForOther" no-data-text="اطلاعاتی وجود ندارد"
                  dense outlined item-text="title" item-value="id" label="معاینه پوست" clearable
                  clear-icon="mdi-close-circle-outline" v-model="patientMediacalExamination.skinExaminationId"
                  autocomplete="off" prepend-inner-icon="mdi-human mdi-18px"></v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="12" class="mt-n2">
                <v-row class="ma-0">
                  <span>چشم</span>
                  <v-divider class="mt-3 mr-3 mb-3"></v-divider>
                </v-row>
                <v-row class="ma-0 mt3">
                  <span>نیستاگموس</span>
                  <v-col cols="1"></v-col>
                  <v-col cols="6" class="mt-n8">
                    <v-radio-group v-model="patientMediacalExamination.hasNystagmus" row>
                      <v-radio label="دارد" :value="true"></v-radio>
                      <v-radio label="ندارد" :value="false"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row class="ma-0 mt-n7">
                  <span>انحراف چشم</span>
                  <v-col cols="1"></v-col>
                  <v-col cols="6" class="mt-n8">
                    <v-radio-group v-model="patientMediacalExamination.hasEyeDeviation" row>
                      <v-radio label="دارد" :value="true"></v-radio>
                      <v-radio label="ندارد" :value="false"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>

              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4">
            <v-row class="ma-0">
              <span>مردمک</span>
              <v-divider class="mt-3 mr-3 ml-3"></v-divider>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="12" class="mt-2">
                <v-row>
                  <span class="mr-10">R</span>
                  <v-spacer></v-spacer>
                  <span>صدا</span>
                  <v-spacer></v-spacer>
                  <span class="ml-8">L</span>
                </v-row>
              </v-col>
              <v-col cols="12" class="mt-n4">
                <v-row>
                  <v-switch color="lightColor" flat dense
                    v-model="patientMediacalExamination.patientPupilExamination.rightNormal" class="mr-6"
                    inset></v-switch>
                  <v-spacer></v-spacer>
                  <span class="mt-4">نرمال</span>
                  <v-spacer></v-spacer>
                  <v-switch flat dense inset color="lightColor"
                    v-model="patientMediacalExamination.patientPupilExamination.leftNormal"></v-switch>
                </v-row>
              </v-col>
              <v-col cols="12" class="mt-n8">
                <v-row>
                  <v-switch color="lightColor" flat dense class="mr-6"
                    v-model="patientMediacalExamination.patientPupilExamination.rightDilate" inset></v-switch>
                  <v-spacer></v-spacer>
                  <span class="mt-4">دیلاته</span>
                  <v-spacer></v-spacer>
                  <v-switch flat dense inset color="lightColor"
                    v-model="patientMediacalExamination.patientPupilExamination.leftDilate"></v-switch>
                </v-row>
              </v-col>
              <v-col cols="12" class="mt-n8">
                <v-row>
                  <v-switch color="lightColor" flat dense class="mr-6" inset
                    v-model="patientMediacalExamination.patientPupilExamination.rightMiotic"></v-switch>
                  <v-spacer></v-spacer>
                  <span class="mt-4">میوتیک</span>
                  <v-spacer></v-spacer>
                  <v-switch flat dense inset color="lightColor"
                    v-model="patientMediacalExamination.patientPupilExamination.leftMiotic"></v-switch>
                </v-row>
              </v-col>
              <v-col cols="12" class="mt-n8">
                <v-row>
                  <v-switch color="lightColor" flat dense class="mr-6" inset
                    v-model="patientMediacalExamination.patientPupilExamination.rightNoAnswer"></v-switch>
                  <v-spacer></v-spacer>
                  <span class="mt-4">بدون پاسخ</span>
                  <v-spacer></v-spacer>
                  <v-switch flat dense inset color="lightColor"
                    v-model="patientMediacalExamination.patientPupilExamination.leftNoAnswer"></v-switch>
                </v-row>
              </v-col>

            </v-row>
            <template v-if="flagShowForm == 5">
              <v-row class="ma-0">
                <span>خونریزی</span>
                <v-divider class="mt-3 mr-3 mb-3"></v-divider>
              </v-row>
              <v-row class="ma-0 mt3">
                <span>خونریزی واژینال</span>
                <v-col cols="1"></v-col>
                <v-col cols="6" class="mt-n8">
                  <v-radio-group v-model="patientMediacalExamination.hasVaginalBleeding" row>
                    <v-radio label="دارد" :value="true"></v-radio>
                    <v-radio label="ندارد" :value="false"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </template>

          </v-col>
          <v-col cols="4">

            <v-row class="ma-0">
              <v-col cols="12" class="mt-n2">
                <v-row class="ma-0">
                  <span>آخرین وعده غذایی</span>
                  <v-divider class="mt-3 mr-3 ml-3"></v-divider>
                </v-row>
              </v-col>
              <v-col cols="12" class="mt-n2">
                <v-text-field dense outlined label="آخرین وعده غذایی" clearable clear-icon="mdi-close-circle-outline"
                  v-model="patientMediacalExamination.lastFood" prepend-inner-icon="mdi-food mdi-18px"></v-text-field>
              </v-col>
              <v-col cols="12" class="mt-n9">
                <v-text-field hide-details type="text" outlined id="user-moveFromStationTime" ref="moveFromStationTime"
                  dense clearable autocomplete="off" @click:clear="clearDateTime('lastFoodDate')"
                  clear-icon="mdi-close-circle-outline" v-model="tempLastFoodDate" @focus="showLastFoodDate = true"
                  @click="showLastFoodDate = true" label="زمان آخرین وعده غذایی"
                  prepend-inner-icon="mdi-calendar-range mdi-18px">
                  <template slot="append">
                    <v-icon @click="showLastFoodDate = true" class="calender-background ml-n3 mt-n2" color="white">
                      mdi-calendar-range mdi-18px
                    </v-icon>
                  </template>
                </v-text-field>
                <date-picker :show="showLastFoodDate" simple v-model="patientMediacalExamination.lastFoodDate"
                  type="datetime" @open="onOpen" @change="dateTimeChange('lastFoodDate')" :editable="true"
                  format="YYYY-MM-DDTHH:mm:ss" display-format="HH:mm:ss jYYYY/jMM/jDD"
                  custom-input="#moveFromStationTime-moveFromStationTime" @close="showLastFoodDate = false" />
              </v-col>
            </v-row>

            <v-row class="ma-0">
              <span>سایر</span>
              <v-divider class="mt-3 mr-3"></v-divider>
            </v-row>
            <v-row>
              <v-col cols="12" class="mt-n1">
                <v-text-field dense outlined label="سایر علائم" clearable clear-icon="mdi-close-circle-outline"
                  v-model="patientMediacalExamination.otherSymptoms"
                  prepend-inner-icon="mdi-text mdi-18px"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="ma-0 mt-2">
      <v-spacer></v-spacer>
      <v-btn rounded color="darkColor" dark @click="nextDialog()">
        ثبت و بعدی ({{ flagShowForm == 1 || flagShowForm == 2 ? 'معاینات سرتاپا' : 'اقدامات درمانی' }})
      </v-btn>
      <v-btn rounded text class="set-btn mx-1" @click="addPatientMedicalExamination()">ثبت</v-btn>
      <v-btn text color="darkColor" @click="closeDialog()">انصراف</v-btn>

    </v-row>
  </v-card>
</template>
<script>
import SharedHelper from '@/Helpers/Shared';
import FollowUpPatientStep9Helper from '@/Helpers/FollowUp/FollowUpPatientPart/FollowUpPatientStep9Helper.js';
import ShearedMixin from '@/Mixins/Shared.js';
import RespiratorySoundMixin from '@/Mixins/FollowUp/RespiratorySoundMixin.js';
import HeartRhythmMixin from '@/Mixins/FollowUp/HeartRhythmMixin.js';
import HeartSoundMixin from '@/Mixins/FollowUp/HeartSoundMixin.js';
import PulseQualityMixin from '@/Mixins/FollowUp/PulseQualityMixin.js';
import PulseRhythmMixin from '@/Mixins/FollowUp/PulseRhythmMixin.js';
import SkinTurgorMixin from '@/Mixins/FollowUp/SkinTurgorMixin.js';
import SkinTemperatureMixin from '@/Mixins/FollowUp/SkinTemperatureMixin.js';
import SkinExaminationMixin from '@/Mixins/FollowUp/SkinExaminationMixin.js';
import AbdomenExaminationMixin from '@/Mixins/FollowUp/AbdomenExaminationMixin';
import PatientMedicalExaminationMixin from '@/Mixins/FollowUp/FollowUpPatientPart/PatientMedicalExaminationMixin.js';
export default {
  mixins: [
    SharedHelper,
    FollowUpPatientStep9Helper,
    ShearedMixin,
    RespiratorySoundMixin,
    HeartRhythmMixin,
    HeartSoundMixin,
    PulseQualityMixin,
    PulseRhythmMixin,
    SkinTurgorMixin,
    SkinTemperatureMixin,
    SkinExaminationMixin,
    AbdomenExaminationMixin,
    PatientMedicalExaminationMixin,
  ],
  mounted() {
    this.mounteLoding();
  },
  props: {
    patientId: {
      type: Number,
      require: true,
      default: null,
    },
    missionType: {
      type: String,
      require: true,
      default: '',
    },
    flagShowForm: {
      type: Number,
      require: true,
      default: null,
    },

  },
  data() {
    return {
      localFlagShowForm: null,
      isGoToNext: false
    }
  },
  methods: {
    mounte: function () {
      this.getPatientMedicalExaminationByIdFunction(this.patientId);
      this.getListOfRespiratorySoundsForOther();
      this.getListOfHeartRhythmsForOther();
      this.getListOfHeartSoundsForOther();
      this.getListOfPulseQualitiesForOther();
      this.getListOfPulseRhythmsForOther();
      this.getListOfSkinTurgorsForOther();
      this.getListOfSkinTemperaturesForOther();
      this.getListOfSkinExaminationsForOther();
    },
    closeDialog() {
      this.$emit('reloadApiFun');
    },
    nextDialog() {
      // this.$emit('goToNextDialog');
      this.isGoToNext = true;
      this.$nextTick(() => {
        this.addPatientMedicalExamination();
      });
    },
  },
  watch: {
    flagShowForm: {
      handler(newVal) {
        this.localFlagShowForm = newVal;
      },
      immediate: true,
    },
  },
};
</script>
<style scoped>
.set-btn {
  background: var(--background-color) !important;
  color: var(--dark-color) !important;
  letter-spacing: normal;
  border: 1px solid var(--dark-color);
}

.probleemBox {
  max-height: 160px !important;
}

.bodyItem {
  max-height: 575px !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.calender-background {
  background: #79747e;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}

.stomach-card {
  background: var(--background-color) !important;
}

.selected-stomach-probleem-part {
  /* height: 25vh; */
  overflow: auto;
}

.customHeight {
  height: calc(100% - 40px) !important;
}

.h-full {
  height: 100% !important;
}
</style>
